/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Position_GpsInputs */

const fr_marker_position_gps = /** @type {(inputs: Marker_Position_GpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position GPS`)
};

const en_marker_position_gps = /** @type {(inputs: Marker_Position_GpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GPS position`)
};

/**
* | output |
* | --- |
* | "GPS position" |
*
* @param {Marker_Position_GpsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const marker_position_gps = /** @type {((inputs?: Marker_Position_GpsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Position_GpsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_position_gps(inputs)
	return en_marker_position_gps(inputs)
});